function SupportMgmt() {
    return ('SupportMgmt');
}

export default SupportMgmt;
